<template>
  <div class="pk-ce__introduction-page-wrapper">
    <div class="pk-page-spacing-flex"></div>
    <div class="pk-ce__introduction-page">
      <div class="pk-flex">
        <router-link v-if="currentCE"
         :to="{path: '/ce/' + currentCE.doc._id + '/matrix'}">
          <img src="../../assets/icons/criticaledition_matrix.svg"
           style="height:30px; width:30px;margin-right:5px">
        </router-link>

        <div class="pk-label">
          selected edition: <span v-if="currentCE">{{currentCE.doc._source['137_cetitle']}}</span>
        </div>
      </div>
      <div class="pk-ce__introduction-body">
        <div style="padding-top: 45px;">
          <ul style="list-style-type: none;">
            <li v-for="(it, i) in navItems" 
            class="pk-label--withborder"
             :class="it.key === selectedNavItem ? 'pk-ce__nav--active' : ''"
             :key="'nv' + i"
             @click="selectedNavItem = it.key">
              {{it.label}}
            </li>
          </ul>
        </div>
        <div class="pk-page-spacing-flex"></div>
        <div class="pk-ce__introduction-content-wrapper">
          <div class="pk-ce__introduction-content">
            <div v-if="selectedNavItem === '137_cenomvers'">
              <section v-for="(obj,k) of makeNominalSlidesetMeta()" :key="k"
               style="margin:5px;">
                <div v-if="typeof obj.text === 'string'">
                  <label v-if="obj.key !== 'Commentary'">{{obj.key}}:&nbsp;</label><span v-html="obj.text"></span>
                </div>

                <template v-if="typeof obj.text === 'object'">
                  <div><label>{{obj.key}}</label></div>
                  <div v-for="(v,t) of obj.text" :key="t">
                    {{t}}: <span>{{v}}</span>
                  </div>
                </template>
              </section>
            </div>
            <div v-html="contentHtml">

            </div>
          </div>
        </div>

        <div class="pk-page-spacing-flex"></div>
        <div class="pk-flex__00auto pk-ce__collationlist">
          <div class="pk-label--withborder" style="width:180px">
            select collation:
          </div>
          <div class="pk-ce__collationlist-content">
            <div>
              <div v-if="currentCE"
               style="margin-bottom: 20px;">
                <router-link :to="{path:'/ce/'+currentCE.doc._id+'/matrix'}">{{currentCE.doc._source['137_cetitle']}} full matrix</router-link>
              </div>
              <div v-for="(ss,ssi) in comparisons" :key="ssi">
                <router-link :to="{path:'/ce/'+currentCE.doc._id+'/subset/'+ss._id}">
                  {{ss._source['132_cptitle']}}
                </router-link>
                <!--<router-link
                   :to="{path:'/ce/set/subset?ceid='+currentCE.doc._id+'&cpid'}">{{ss.cemascomment}}</router-link>-->
              </div>
            </div>
          </div>
        </div>
        <div class="pk-page-spacing-flex"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { FudapiService } from '../../utils/fudapi.service';
import Util from '../../utils/util';

export default Vue.extend({
  created() {
    this.$store.dispatch('fetchAllCriticalEditions', this.startLoad);
  },
  data() {
    return {
      startLoad: {
        done: false,
        threads: []
      },
      firstRunContentHtml: true,
      selectedNavItem: '137_ceintro',
      contentHtmlObj: {
        str: 'loading...'
      },
      navItems: [
        {
          key: '137_ceintro',
          label: 'Introduction',
          content: ''
        },
        {
          key: '137_cenomvers', // TODO: 先显示metadata， 然后 commentar, 然后才是137_cenomvers
          label: 'Nominal version',
          content: ''
        },
        {
          key: '137_cecollation',
          label: 'Collation',
          content: ''
        },
        {
          key: '137_ceperformance',
          label: 'Performance',
          content: ''
        },
        {
          key: '137_cehistocont',
          label: 'Historical context',
          content: ''
        }
      ]
    };
  },
  methods: {
    _getYear(str) {
      if (str === '0000-00-00') {
        return '';
      }
      if (!str) {
        return '';
      }
      return str.split('-')[0];
    }
  },
  mounted() {
    if (this.$matomo) {
      this.$matomo.trackPageView('Critical Edition Introduction');
    }
    Util.checkStartLoad({
      loadingCount: 0,
      startLoad: this.startLoad,
      retryCondition: () => { 
        return !this.currentCE;
      },
      allDoneCallback: () => {
        const ce = this.currentCE;
        for (const navItem of this.navItems) {
          const oriContent = ce.doc._source[navItem.key];
          const obj = {
            str: oriContent
          };
          this.startLoad.threads.push(FudapiService.transformFreetext(obj).subscribe(
            () => null,
            err => {
              console.log(err);
            }, 
            () => {
              navItem.content = obj.str;
            }
          ));
        }
      }
    });
  },
  destroyed() {
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },
  computed: {
    contentHtml() {
      if (!this.currentCE || !this.currentCE.doc) {
        return '';
      }
      for (const navItem of this.navItems) {
        if (navItem.key === this.selectedNavItem) {
          return navItem.content;
        }
      }
    },
    criticalEditions() {
      return this.$store.state.criticalEditions;
    },
    currentCE() {
      const id = this.$route.params.ceid;
      return this.criticalEditions.find(a => a.doc._id === id);
    },

    slidesets() {
      return this.currentCE ? this.currentCE.slidesets : {};
    },
    comparisons() {
      return this.currentCE ? this.currentCE.comparisons : {};
    },
    nominalVersion() {
      if (this.slidesets) {
        let nv;
        Object.values(this.slidesets).find(sl => {
          if (sl.doc && sl.doc._source['54_sstypeset'] === 'nominal version') {
            nv = sl;
          }
        });
        return nv;
      }
    }
  },
  methods: {
    makeNominalSlidesetMeta() {
      const current = this.nominalVersion;
      if (!current || !current.doc) {
        return '';
      }
      const meta = current.getToShowMetadata();
      return meta;
    },
  }
});
</script>

<style lang="scss" scoped>

@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';

.pk-ce__introduction-page-wrapper {
  @extend .pk-flex;
  padding-top: 30px;
}

.pk-ce__introduction-page {
  @extend .pk-flex__1;
  @extend .pk-flex--column;
  font-size: 12px;
}

.pk-ce__introduction-body {
  @extend .pk-flex__1;
  @extend .pk-flex;
  min-height: 0;
  
  ul {
    padding: 0px;
    margin: 0px;
  }
  ul li {
    width: 180px;
    margin-bottom: 10px;
    cursor: pointer;
    &:hover {
      color: #fff;
      background-color: rgb(201, 201, 201);
    }
  }
  .pk-ce__introduction-content-wrapper {
    @extend .pk-flex__1;
    padding: 45px 0px 20px 0;
  }
  .pk-ce__introduction-content {
    border: 2px solid #bbbbbb;
    background-color: rgb(240, 240, 240);
    padding: 20px;
    max-height: 100%;
    overflow: auto;
  }
}

.pk-label {
  background-color: #d8dff2;
  padding: 5px 10px;
  height: 30px;
  font-size: 14px;
}

.pk-ce__nav--active {
  background-color: rgb(201, 201, 201);
  color: #fff;
}

.pk-ce__collationlist {
  padding-bottom: 20px;

  .pk-ce__collationlist-content {
    margin-top:12px;
    background-color:rgb(228,228,228);
    padding: 10px 20px 20px 20px;
    max-height: 100%;
    overflow: auto;
  }
}
</style>